/* Cart drawer: <cart-drawer> custom element, cart rendering, quantity/discount,
   free-shipping bar, and shield/consumable upsells. Loaded by snippets/cart-drawer.liquid. */
(function () {
  const AMOUNT_PLACEHOLDER = '\x7b\x7b amount \x7d\x7d';
  const AMOUNT_RE = /\x7b\x7b\s*amount\s*\x7d\x7d/g;
  const COUNT_PLACEHOLDER = '\x7b\x7b count \x7d\x7d';

  // Locale/market-aware root ("/" on the primary domain, e.g. "/en-ca/" under a subfolder).
  function cdCartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function cdStorageGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function cdStorageSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
      sessionStorage.setItem('shield-upsell-cached-at', String(Date.now()));
    } catch (e) {}
  }
  function cdStorageRemove(key) {
    try { sessionStorage.removeItem(key); } catch (e) {}
  }

  function cdEscapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // Keeps only bold/italic tags (no attributes) from merchant rich text; other
  // tags are unwrapped to their text, and script/style content is dropped.
  var CD_INLINE_TAGS = { STRONG: 1, B: 1, EM: 1, I: 1 };
  var CD_DROP_TAGS = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, IFRAME: 1, OBJECT: 1, EMBED: 1 };
  function cdSanitizeInlineHtml(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = String(html == null ? '' : html);
    (function clean(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 1) {
          var tag = child.tagName.toUpperCase(); // SVG/MathML tags are lowercase
          if (CD_DROP_TAGS[tag] || tag === 'SVG' || tag === 'MATH') { child.remove(); return; }
          clean(child);
          if (CD_INLINE_TAGS[tag]) {
            while (child.attributes.length) child.removeAttribute(child.attributes[0].name);
          } else {
            child.replaceWith.apply(child, Array.prototype.slice.call(child.childNodes));
          }
        } else if (child.nodeType !== 3) {
          child.remove();
        }
      });
    })(tpl.content);
    var box = document.createElement('div');
    box.appendChild(tpl.content);
    return box.innerHTML.trim();
  }

  function cdNormalizeText(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  // Accessories whose `type` is listed in item.consumable_types (a comma-separated
  // metafield string, e.g. "Pinlock, Tear Offs"). Returns null when the item lists
  // no types, so each caller can choose its own fallback (none vs. all).
  function cdFilterByConsumableTypes(item, accessories) {
    if (!item || typeof item.consumable_types !== 'string') return null;
    var allowedTypes = item.consumable_types.split(',').map(function (t) { return t.trim(); });
    if (!allowedTypes.length) return null;
    return accessories.filter(function (a) {
      return a.type && allowedTypes.indexOf(a.type) !== -1;
    });
  }

  var CD_PLACEHOLDER_IMG = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">' +
    '<rect width="60" height="60" rx="6" fill="#e5e5e5"/>' +
    '<path d="M30 14c8 3 12 4 12 4v14c0 9-6 14-12 17-6-3-12-8-12-17V18s4-1 12-4z" fill="none" stroke="#999" stroke-width="2"/>' +
    '</svg>'
  );

  function cdRenderUpsellCard(item, opts) {
    var img = item.image ? cdEscapeHtml(item.image) : CD_PLACEHOLDER_IMG;
    var priceHtml = '';
    if (opts.showPrice) {
      var pct = Number(item.bundle_discount_percent);
      if (pct > 0 && pct < 100) {
        var discounted = Math.round(item.price * (1 - pct / 100));
        var saveText = (opts.saveLabel || 'Save {percent}% bundled with your helmet').replace('{percent}', String(pct));
        priceHtml =
          '<span class="cart-drawer__shield-upsell-price cart-drawer__shield-upsell-price--bundle">' +
            '<span class="cart-drawer__shield-upsell-price-original">' + cdEscapeHtml(opts.formatMoney(item.price)) + '</span>' +
            '<span class="cart-drawer__shield-upsell-price-discounted">' + cdEscapeHtml(opts.formatMoney(discounted)) + '</span>' +
          '</span>' +
          '<span class="cart-drawer__shield-upsell-save-badge">' + cdEscapeHtml(saveText) + '</span>';
      } else {
        priceHtml = '<span class="cart-drawer__shield-upsell-price">' + cdEscapeHtml(opts.formatMoney(item.price)) + '</span>';
      }
    }
    var readinessContent = item.readiness_html ? cdSanitizeInlineHtml(item.readiness_html) : cdEscapeHtml(item.readiness);
    var readinessHtml = (opts.showReadiness && item.readiness) ? '<span class="cart-drawer__shield-upsell-readiness">' + readinessContent + '</span>' : '';
    var badgeHtml = '';
    if (item.badge_text) {
      badgeHtml += '<span class="cart-drawer__shield-upsell-tag">' + cdEscapeHtml(item.badge_text) + '</span>';
    }
    var qty = Number(item.inventory_quantity);
    if (item.inventory_quantity != null && qty > 0 && qty <= 5) {
      var lowStockText = (opts.lowStockLabel || 'Only {count} left').replace('{count}', String(qty));
      badgeHtml += '<span class="cart-drawer__shield-upsell-tag cart-drawer__shield-upsell-tag--low-stock">' + cdEscapeHtml(lowStockText) + '</span>';
    }
    return (
      '<div class="cart-drawer__shield-upsell-item">' +
        '<img src="' + img + '" alt="' + cdEscapeHtml(item.title) + '" width="60" height="60" loading="lazy">' +
        '<div class="cart-drawer__shield-upsell-info">' +
          badgeHtml +
          '<span class="cart-drawer__shield-upsell-title">' + cdEscapeHtml(item.title) + '</span>' +
          readinessHtml +
          priceHtml +
        '</div>' +
        '<button type="button" class="cart-drawer__shield-upsell-add" data-shield-add="' + item.variant_id + '">' + cdEscapeHtml(opts.addText) + '</button>' +
      '</div>'
    );
  }

  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.emptyText = this.dataset.emptyText || 'Your cart is empty';
      this.removeText = this.dataset.removeText || 'Remove';
      this.decreaseQuantityText = this.dataset.decreaseQuantityText || 'Decrease quantity';
      this.increaseQuantityText = this.dataset.increaseQuantityText || 'Increase quantity';
      this.moneyFormat = this.dataset.moneyFormat || '$' + AMOUNT_PLACEHOLDER;
      this.shippingQualified = this.dataset.shippingQualified || "You've qualified for free shipping!";
      this.shippingThreshold = this.dataset.shippingThreshold || "You're " + AMOUNT_PLACEHOLDER + ' away from free shipping.';
      this.shippingThresholdCents = (parseInt(this.dataset.shippingAmount, 10) || 150) * 100;
      this.isB2B = this.dataset.b2b === 'true';
      this.helmetThreshold = parseInt(this.dataset.helmetThreshold, 10) || 6;
      this.shippingThresholdB2B = this.dataset.shippingThresholdB2b || 'Add ' + COUNT_PLACEHOLDER + ' more helmet(s) for free shipping.';
      this.shieldAddText = this.dataset.shieldAddText || 'Add';
      this.shieldAddErrorText = this.dataset.shieldAddErrorText || "Couldn't add — tap to retry";
      this.showShieldReadiness = this.dataset.showShieldReadiness !== 'false';
      this.showShieldPrice = this.dataset.showShieldPrice !== 'false';
      this.bundleSavingsLabel = this.dataset.bundleSavingsLabel || 'Save {percent}% bundled with your helmet';
      this.lowStockLabel = this.dataset.lowStockLabel || 'Only {count} left';
      this.discountApplied = this.dataset.discountApplied || 'Discount applied';
      this.discountApplying = this.dataset.discountApplying || 'Applying\u2026';
      this.discountInvalid = this.dataset.discountInvalid || 'Invalid discount code';
      this.discountNotApplicable = this.dataset.discountNotApplicable || 'This code can\u2019t be used with your current cart';
      this.panel = this.querySelector('.cart-drawer__panel');
      this.itemsContainer = this.querySelector('[data-cart-items]');
      this.footer = this.querySelector('[data-cart-footer]');
      this.cartCount = this.querySelector('[data-cart-count]');
      this.cartSubtotal = this.querySelector('[data-cart-subtotal]');
      this.shipping = this.querySelector('[data-cart-shipping]');
      this.shippingBar = this.querySelector('[data-shipping-bar]');
      this.shippingProgress = this.querySelector('[data-shipping-progress]');
      this.shippingMessage = this.querySelector('[data-shipping-message]');
      this.discountInput = this.querySelector('[data-discount-input]');
      this.discountApply = this.querySelector('[data-discount-apply]');
      this.discountMessage = this.querySelector('[data-discount-message]');
      this.closeButtons = this.querySelectorAll('[data-cart-drawer-close]');
      this.shieldSection = this.querySelector('[data-shield-upsell]');
      this.shieldItems = this.querySelector('[data-shield-items]');
      this._shieldHideTimer = null;
    }

    connectedCallback() {
      this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.close()));

      this.panel.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.close();
      });

      this.panel.addEventListener('click', (e) => {
        if (e.target === this.panel) this.close();
      });

      this.discountApply.addEventListener('click', () => this.applyDiscount());

      document.addEventListener('cart-drawer:open', () => this.open());

      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-cart-drawer-open]');
        if (trigger) {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        }
      });

      document.addEventListener('cart-drawer:shield-upsell', (e) => {
        if (cdStorageGet('shield-upsell-dismissed') === 'true') return;
        this.renderShieldUpsell(e.detail.shields, e.detail.heading, e.detail.includedShield || null, e.detail.accessories || null, e.detail.upgrades || null);
      });

      this.addEventListener('click', (e) => {
        var addBtn = e.target.closest('[data-shield-add]');
        if (addBtn) {
          e.preventDefault();
          this.handleShieldAdd(addBtn.dataset.shieldAdd);
          return;
        }
        var dismissBtn = e.target.closest('[data-shield-dismiss]');
        if (dismissBtn) {
          this.hideShieldUpsell(true);
        }
      });

      if (this.itemsContainer) {
        this.itemsContainer.addEventListener('click', (e) => {
          const target = e.target.closest('[data-qty-down], [data-qty-up], [data-item-remove]');
          if (!target) return;
          if (target.hasAttribute('data-qty-down')) {
            this.changeItem(target.dataset.qtyDown, -1);
          } else if (target.hasAttribute('data-qty-up')) {
            this.changeItem(target.dataset.qtyUp, 1);
          } else if (target.hasAttribute('data-item-remove')) {
            this.changeItem(target.dataset.itemRemove, 0);
          }
        });
      } else {
        console.warn('CartDrawer: itemsContainer is null — quantity/remove buttons will not work');
      }
    }

    formatMoney(cents) {
      try {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents);
        }
        var value = (Math.round(cents) / 100).toFixed(2);
        return this.moneyFormat.replace(AMOUNT_RE, value);
      } catch (e) {
        return '$' + (Math.round(cents) / 100).toFixed(2);
      }
    }

    async open() {
      if (this.panel.open) {
        document.dispatchEvent(new CustomEvent('cart-drawer:opened'));
        return;
      }
      var cart = await this.fetchCart();
      if (cart) this.checkCartForShieldUpsell(cart);
      this.panel.showModal();
      requestAnimationFrame(() => {
        this.panel.classList.add('cart-drawer__panel--open');
        var closeBtn = this.closeButtons[0];
        if (closeBtn) closeBtn.focus();
      });
      document.body.style.overflow = 'hidden';
      document.dispatchEvent(new CustomEvent('cart-drawer:opened'));
    }

    close() {
      if (!this.panel.open) return;
      this.panel.classList.remove('cart-drawer__panel--open');
      document.body.style.overflow = '';
      setTimeout(() => { this.panel.close(); }, 300);
    }

    async fetchCart() {
      this.itemsContainer.innerHTML = '<div class="cart-drawer__loading"></div>';
      try {
        const response = await fetch(cdCartUrl('cart.js'));
        const cart = await response.json();
        this.render(cart);
        return cart;
      } catch (err) {
        console.error('CartDrawer fetchCart error:', err);
        this.itemsContainer.innerHTML = `
          <div class="cart-drawer__empty">
            <p>${this.emptyText}</p>
          </div>`;
        return null;
      }
    }

    render(cart) {
      this.cartCount.textContent = cart.item_count;
      this.updateHeaderCount(cart.item_count);

      if (cart.item_count === 0) {
        cdStorageRemove('shield-upsell-dismissed');
        this.itemsContainer.innerHTML = `
          <div class="cart-drawer__empty">
            <p>${this.emptyText}</p>
          </div>`;
        this.footer.hidden = true;
        this.shipping.hidden = true;
        this.hideShieldUpsell(true);
        return;
      }

      this.footer.hidden = false;
      this.renderItems(cart.items);
      this.formatReadinessNotes();
      this.renderSubtotal(cart);
      this.renderShipping(cart);
      this.renderDiscount(cart);
    }

    // The cart line stores readiness as plain text (it's saved on the order).
    // For display, swap in the product's formatted version (bold/italic) from
    // the product-readiness section, fetched once per product per visit. It's
    // only used when its text matches the note, so the drawer never shows
    // something different from what was added.
    async formatReadinessNotes() {
      var notes = Array.prototype.slice.call(this.itemsContainer.querySelectorAll('[data-readiness-handle]'));
      if (!notes.length) return;
      var cache = this._readinessCache || {};
      try { Object.assign(cache, JSON.parse(cdStorageGet('readiness-html-cache') || '{}')); } catch (e) {}
      this._readinessCache = cache;
      var CD_READINESS_TTL = 30 * 60 * 1000;
      var handles = notes.map(function (n) { return n.dataset.readinessHandle; })
        .filter(function (h, i, all) { return h && all.indexOf(h) === i; });

      await Promise.all(handles.map(async function (handle) {
        var hit = cache[handle];
        if (hit && Date.now() - hit.at < CD_READINESS_TTL) return;
        try {
          var res = await fetch(cdCartUrl('products/' + encodeURIComponent(handle) + '?sections=product-readiness'));
          if (!res.ok) return;
          var data = await res.json();
          var doc = new DOMParser().parseFromString(data['product-readiness'] || '', 'text/html');
          var tpl = doc.querySelector('template[data-readiness-html]');
          cache[handle] = { html: tpl ? cdSanitizeInlineHtml(tpl.innerHTML) : '', at: Date.now() };
        } catch (e) {}
      }));

      try { sessionStorage.setItem('readiness-html-cache', JSON.stringify(cache)); } catch (e) {}

      notes.forEach(function (note) {
        var hit = cache[note.dataset.readinessHandle];
        if (!hit || !hit.html) return;
        var probe = document.createElement('span');
        probe.innerHTML = hit.html;
        if (cdNormalizeText(probe.textContent) === cdNormalizeText(note.textContent)) {
          note.innerHTML = hit.html;
        }
      });
    }

    renderItems(items) {
      this.itemsContainer.innerHTML = items.map((item, index) => `
        <div class="cart-drawer__item" data-item-id="${item.key}">
          <div class="cart-drawer__item-image">
            <img src="${cdEscapeHtml(item.image)}" alt="${cdEscapeHtml(item.product_title)}" loading="lazy" width="80" height="80">
          </div>
          <div class="cart-drawer__item-details">
            <div class="cart-drawer__item-header">
              <p class="cart-drawer__item-title">
                <a href="${cdEscapeHtml(item.url)}">${cdEscapeHtml(item.product_title)}</a>
              </p>
              <span class="cart-drawer__item-price">${this.formatMoney(item.original_price)}</span>
            </div>
            ${item.variant_title ? `<span class="cart-drawer__item-variant">${cdEscapeHtml(item.variant_title)}</span>` : ''}
            ${item.selling_plan_allocation ? `<span class="cart-drawer__item-variant">${cdEscapeHtml(item.selling_plan_allocation.selling_plan.name)}</span>` : ''}
            ${item.properties && item.properties._readiness ? `<span class="cart-drawer__item-readiness" data-readiness-handle="${cdEscapeHtml(item.handle)}">${cdEscapeHtml(item.properties._readiness)}</span>` : ''}
            <button class="cart-drawer__item-remove" data-item-remove="${item.key}">${this.removeText}</button>
            <div class="cart-drawer__item-bottom">
              <div class="cart-drawer__item-quantity">
                <button type="button" class="cart-drawer__item-qty-btn" data-qty-down="${item.key}" aria-label="${this.decreaseQuantityText}"${item.quantity <= 1 ? ' disabled' : ''}>
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
                <span class="cart-drawer__item-qty-value">${item.quantity}</span>
                <button type="button" class="cart-drawer__item-qty-btn" data-qty-up="${item.key}" aria-label="${this.increaseQuantityText}">
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              </div>
              <span class="cart-drawer__item-line-price">${this.formatMoney(item.line_price)}</span>
            </div>
          </div>
        </div>
      `).join('');
    }

    async changeItem(lineId, delta) {
      const itemEl = this.itemsContainer.querySelector(`[data-item-id="${lineId}"]`);
      if (!itemEl) return;

      const qtyEl = itemEl.querySelector('.cart-drawer__item-qty-value');
      const currentQty = parseInt(qtyEl.textContent, 10);
      const newQty = delta === 0 ? 0 : currentQty + delta;
      if (newQty < 0) return;

      try {
        const response = await fetch(cdCartUrl('cart/change.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: lineId, quantity: newQty })
        });
        if (!response.ok) {
          const text = await response.text();
          throw new Error(text || response.statusText);
        }
        const cart = await response.json();

        this.cartCount.textContent = cart.item_count;
        this.updateHeaderCount(cart.item_count);

        if (newQty === 0) {
          itemEl.remove();
        } else {
          qtyEl.textContent = newQty;
          const updatedItem = cart.items.find(i => String(i.key) === String(lineId));
          if (updatedItem) {
            const linePriceEl = itemEl.querySelector('.cart-drawer__item-line-price');
            if (linePriceEl) linePriceEl.textContent = this.formatMoney(updatedItem.line_price);
          }
          const downBtn = itemEl.querySelector('[data-qty-down]');
          if (downBtn) downBtn.disabled = newQty <= 1;
        }

        if (cart.item_count === 0) {
          this.render(cart);
          return;
        }

        this.footer.hidden = false;
        this.renderSubtotal(cart);
        this.renderShipping(cart);
        this.renderDiscount(cart);
        if (delta > 0) this.checkCartForShieldUpsell(cart);
      } catch (err) {
        console.error('CartDrawer changeItem error:', err);
        await this.fetchCart();
      }
    }

    _defaultShieldHeading() {
      var el = this.shieldSection;
      return el ? el.dataset.defaultShieldHeading : 'Add a shield to your helmet?';
    }
    _defaultConsumableHeading() {
      var el = this.shieldSection;
      return el ? el.dataset.defaultConsumableHeading : 'Add Consumables?';
    }

    _checkConsumableUpsell(cart, shields) {
      var cartShields = [];
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        for (var j = 0; j < shields.length; j++) {
          if (String(shields[j].product_id) === String(item.product_id) && shields[j].consumable_types) {
            cartShields.push(shields[j]);
            break;
          }
        }
      }
      if (!cartShields.length) return;

      var productId = cdStorageGet('shield-upsell-product-id');
      var consumableData = null;
      var prodPanel = document.querySelector('[data-product-id="' + productId + '"] [data-cs-upsell-data]');
      if (prodPanel) {
        try {
          var pd = JSON.parse(prodPanel.textContent);
          if (pd.accessories && pd.accessories.length) consumableData = pd.accessories;
        } catch(e) {}
      } else {
        var cp = document.querySelector('[data-consumable-products-json]');
        if (cp && cp.textContent && cp.textContent !== '[]') {
          try { consumableData = JSON.parse(cp.textContent); } catch(e) {}
        }
      }
      if (!consumableData || !consumableData.length) return;

      var seen = {};
      var matchingConsumables = [];
      for (var i = 0; i < cartShields.length; i++) {
        var matches = cdFilterByConsumableTypes(cartShields[i], consumableData);
        if (!matches) continue;
        for (var j = 0; j < matches.length; j++) {
          var c = matches[j];
          if (!seen[c.variant_id]) {
            seen[c.variant_id] = true;
            matchingConsumables.push(c);
          }
        }
      }
      if (!matchingConsumables.length) return;

      cdStorageSet('shield-upsell-consumable-data', JSON.stringify(matchingConsumables));
      var heading = this._defaultConsumableHeading();
      cdStorageSet('shield-upsell-consumable-heading', heading);
      document.dispatchEvent(new CustomEvent('cart-drawer:shield-upsell', {
        detail: { shields: matchingConsumables, heading: heading }
      }));
    }

    checkCartForShieldUpsell(cart) {
      if (!cart || !cart.items) return;

      // Cached upsell data can go stale if a shield/accessory sells out or is
      // unpublished mid-session; rather than keep offering it indefinitely,
      // treat data older than 30 minutes as expired and simply show nothing.
      var cachedAt = Number(cdStorageGet('shield-upsell-cached-at'));
      var CD_MAX_UPSELL_CACHE_AGE_MS = 30 * 60 * 1000;
      if (!cachedAt || (Date.now() - cachedAt) > CD_MAX_UPSELL_CACHE_AGE_MS) return;

      var includedRaw = cdStorageGet('shield-upsell-included-data');
      if (includedRaw) {
        var includedShield;
        try { includedShield = JSON.parse(includedRaw); } catch(e) { includedShield = null; }
      if (includedShield) {
          var upgradesRaw = cdStorageGet('shield-upsell-upgrades-data');
          var accessoriesRaw = cdStorageGet('shield-upsell-accessories-data');
          var upgrades = null;
          var accessories = null;
          try { upgrades = upgradesRaw ? JSON.parse(upgradesRaw) : null; } catch(e) {}
          try { accessories = accessoriesRaw ? JSON.parse(accessoriesRaw) : null; } catch(e) {}
          if (includedShield.consumable_types && accessories && accessories.length) {
            accessories = cdFilterByConsumableTypes(includedShield, accessories);
          }
          this.renderShieldUpsell(null, null, includedShield, accessories, upgrades);
          return;
        }
      }

      var raw = cdStorageGet('shield-upsell-data');
      var productId = cdStorageGet('shield-upsell-product-id');
      if (!raw || !productId) return;
      var shields;
      try { shields = JSON.parse(raw); } catch(e) { return; }
      if (!shields || !shields.length) return;
      var shieldIds = shields.map(function(s) { return s.product_id; });
      var helmetQty = 0;
      var shieldQty = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (String(item.product_id) === productId) helmetQty += item.quantity;
        if (shieldIds.indexOf(item.product_id) !== -1) shieldQty += item.quantity;
      }
      if (helmetQty <= shieldQty) {
        this._checkConsumableUpsell(cart, shields);
        return;
      }

      var prodPanel = document.querySelector('[data-product-id="' + productId + '"] [data-cs-upsell-data]');
      if (prodPanel) {
        try {
          var pd = JSON.parse(prodPanel.textContent);
          if (pd.accessories && pd.accessories.length) {
            cdStorageSet('shield-upsell-consumable-data', JSON.stringify(pd.accessories));
            var accHeading = document.querySelector('.cs__sticky-cart')?.dataset.accessoryHeading || this._defaultConsumableHeading();
            cdStorageSet('shield-upsell-consumable-heading', accHeading);
          }
        } catch(e) {}
      } else {
        var cp = document.querySelector('[data-consumable-products-json]');
        if (cp && cp.textContent && cp.textContent !== '[]') {
          cdStorageSet('shield-upsell-consumable-data', cp.textContent);
          var h = document.querySelector('[data-consumable-heading]');
          cdStorageSet('shield-upsell-consumable-heading', h ? h.dataset.consumableHeading : this._defaultConsumableHeading());
        }
      }

      var headingEl = document.querySelector('[data-shield-heading]');
      var heading = headingEl ? headingEl.dataset.shieldHeading : this._defaultShieldHeading();
      this.renderShieldUpsell(shields, heading);
    }

    renderSubtotal(cart) {
      this.cartSubtotal.textContent = this.formatMoney(cart.total_price);
    }

    renderShipping(cart) {
      const currentLabel = this.querySelector('[data-shipping-current]');

      if (this.isB2B) {
        const helmetCount = cart.items.reduce(function (sum, item) {
          const isHelmet = item.properties && item.properties._is_helmet;
          return isHelmet ? sum + item.quantity : sum;
        }, 0);

        if (currentLabel) currentLabel.textContent = String(helmetCount);

        const remainingHelmets = this.helmetThreshold - helmetCount;
        if (remainingHelmets <= 0) {
          this.shipping.hidden = false;
          this.shippingProgress.style.width = '100%';
          this.shippingMessage.textContent = this.shippingQualified;
          this.shipping.classList.add('cart-drawer__shipping--qualified');
          if (this.shippingBar) this.shippingBar.setAttribute('aria-valuenow', '100');
        } else {
          this.shipping.hidden = false;
          const pct = Math.min((helmetCount / this.helmetThreshold) * 100, 100);
          this.shippingProgress.style.width = `${pct}%`;
          this.shippingMessage.textContent =
            this.shippingThresholdB2B.replace(COUNT_PLACEHOLDER, String(remainingHelmets));
          this.shipping.classList.remove('cart-drawer__shipping--qualified');
          if (this.shippingBar) this.shippingBar.setAttribute('aria-valuenow', String(Math.round(pct)));
        }
        return;
      }

      if (currentLabel) currentLabel.textContent = this.formatMoney(cart.total_price);

      const remaining = this.shippingThresholdCents - cart.total_price;
      let pct;
      if (remaining <= 0) {
        this.shipping.hidden = false;
        pct = 100;
        this.shippingProgress.style.width = '100%';
        this.shippingMessage.textContent = this.shippingQualified;
        this.shipping.classList.add('cart-drawer__shipping--qualified');
      } else {
        this.shipping.hidden = false;
        pct = Math.min((cart.total_price / this.shippingThresholdCents) * 100, 100);
        this.shippingProgress.style.width = `${pct}%`;
        this.shippingMessage.textContent =
          this.shippingThreshold.replace(AMOUNT_PLACEHOLDER, this.formatMoney(remaining));
        this.shipping.classList.remove('cart-drawer__shipping--qualified');
      }
      if (this.shippingBar) this.shippingBar.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    // Shopify keeps a code on the cart even when it doesn't apply (applicable: false),
    // so only an applicable one counts as applied.
    findDiscountCode(cart, code) {
      const codes = (cart && cart.discount_codes) || [];
      if (!code) return codes.find((d) => d.applicable) || null;
      return codes.find((d) => d.code.toLowerCase() === code.toLowerCase()) || null;
    }

    renderDiscount(cart) {
      const applied = this.findDiscountCode(cart);
      if (applied) {
        this.discountInput.value = applied.code;
        this.discountMessage.hidden = false;
        this.discountMessage.textContent = this.discountApplied;
        this.discountMessage.style.color = '#2e7d32';
      }
    }

    async applyDiscount() {
      const code = this.discountInput.value.trim();
      if (!code) return;

      this.discountMessage.hidden = false;
      this.discountMessage.textContent = this.discountApplying;

      try {
        const response = await fetch(cdCartUrl('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount_code: code })
        });
        if (!response.ok) throw new Error();
        // update.js answers 200 even for unknown codes; the returned cart says
        // whether the code was actually accepted.
        const match = this.findDiscountCode(await response.json(), code);
        await this.fetchCart();
        this.discountMessage.hidden = false;
        if (match && match.applicable) {
          this.discountMessage.textContent = this.discountApplied;
          this.discountMessage.style.color = '#2e7d32';
        } else {
          this.discountMessage.textContent = match ? this.discountNotApplicable : this.discountInvalid;
          this.discountMessage.style.color = '#d32f2f';
        }
      } catch (err) {
        console.error('CartDrawer applyDiscount error:', err);
        this.discountMessage.hidden = false;
        this.discountMessage.textContent = this.discountInvalid;
        this.discountMessage.style.color = '#d32f2f';
      }
    }

    renderShieldUpsell(shields, heading, includedShield, accessories, upgrades) {
      if (!this.shieldSection || !this.shieldItems) return;
      if (this._shieldHideTimer) {
        clearTimeout(this._shieldHideTimer);
        this._shieldHideTimer = null;
      }
      this.shieldSection.classList.remove('cart-drawer__shield-upsell--visible');
      this.shieldSection.hidden = false;
      var headingEl = this.shieldSection.querySelector('.cart-drawer__shield-upsell-heading');

      if (includedShield) {
        var headingTemplate = this.shieldSection.dataset.defaultIncludesHeading || 'This helmet includes a [shield_name]';
        if (headingEl) headingEl.textContent = headingTemplate.replace('[shield_name]', includedShield.title);

        var html = '';
        var actualUpgrades = upgrades && upgrades.length ? upgrades : (shields && shields.length ? shields : []);

        var filteredAccessories = null;
        if (includedShield && includedShield.consumable_types && accessories && accessories.length) {
          filteredAccessories = cdFilterByConsumableTypes(includedShield, accessories);
        }

        var cardOpts = {
          showReadiness: this.showShieldReadiness,
          showPrice: this.showShieldPrice,
          addText: this.shieldAddText,
          saveLabel: this.bundleSavingsLabel,
          lowStockLabel: this.lowStockLabel,
          formatMoney: this.formatMoney.bind(this)
        };

        if (filteredAccessories && filteredAccessories.length) {
          html += '<div class="cart-drawer__shield-upsell-section-heading">' + cdEscapeHtml(this._includesConsumablesHeading()) + '</div>';
          filteredAccessories.forEach(function(a) {
            html += cdRenderUpsellCard(a, cardOpts);
          });
        }

        if (actualUpgrades.length) {
          var groups = {};
          actualUpgrades.forEach(function(s) {
            var series = (s.shield_series && s.shield_series.trim()) || 'Other';
            if (!groups[series]) groups[series] = [];
            groups[series].push(s);
          });
          Object.keys(groups).forEach(function(series) {
            html += '<div class="cart-drawer__shield-upsell-section-heading">' + cdEscapeHtml(series) + ' ' + cdEscapeHtml(this._upgradeShieldsHeading()) + '</div>';
            groups[series].forEach(function(s) {
              html += cdRenderUpsellCard(s, cardOpts);
            });
          }, this);
        }

        this.shieldItems.innerHTML = html;
        this.shieldSection.dataset.shieldItems = JSON.stringify(actualUpgrades.concat(accessories || []));
        this.shieldSection.dataset.includesMode = 'true';
      } else {
        if (headingEl) headingEl.textContent = heading || this._defaultShieldHeading();
        var groups = {};
        shields.forEach(function(s) {
          var t = (s.type && s.type.trim()) || 'Other';
          if (!groups[t]) groups[t] = [];
          groups[t].push(s);
        });
        var types = Object.keys(groups);
        var cardOpts2 = {
          showReadiness: this.showShieldReadiness,
          showPrice: this.showShieldPrice,
          addText: this.shieldAddText,
          saveLabel: this.bundleSavingsLabel,
          lowStockLabel: this.lowStockLabel,
          formatMoney: this.formatMoney.bind(this)
        };
        this.shieldItems.innerHTML = types.map(function(type) {
          var sectionHtml = '';
          if (types.length > 1) {
            sectionHtml += '<div class="cart-drawer__shield-upsell-section-heading">' + cdEscapeHtml(type) + '</div>';
          }
          sectionHtml += groups[type].map(function(s) {
            return cdRenderUpsellCard(s, cardOpts2);
          }).join('');
          return sectionHtml;
        }).join('');
        this.shieldSection.dataset.shieldItems = JSON.stringify(shields);
        this.shieldSection.dataset.includesMode = 'false';
      }

      this._prepConsumableData(accessories, includedShield);

      requestAnimationFrame(() => {
        this.shieldSection.classList.add('cart-drawer__shield-upsell--visible');
      });
    }

    _prepConsumableData(accessories, includedShield) {
      if (!accessories || !accessories.length) return;
      var toStore = accessories;
      if (includedShield && includedShield.consumable_types) {
        toStore = cdFilterByConsumableTypes(includedShield, accessories) || accessories;
      }
      if (toStore && toStore.length) {
        cdStorageSet('shield-upsell-consumable-data', JSON.stringify(toStore));
      }
    }

    _includesConsumablesHeading() {
      var el = this.shieldSection;
      return el ? el.dataset.defaultConsumablesHeading : 'Consumables';
    }

    _upgradeShieldsHeading() {
      var el = this.shieldSection;
      return el ? el.dataset.defaultUpgradesHeading : 'Shields';
    }

    hideShieldUpsell(clearData) {
      if (!this.shieldSection) return;
      var dontShow = this.querySelector('[data-shield-dont-show]');
      if (dontShow && dontShow.checked) {
        cdStorageSet('shield-upsell-dismissed', 'true');
      }
      if (clearData) {
        // A real user dismissal (the X icon or the "Dismiss" button) ends the
        // whole chain, not just the currently-visible step - otherwise the
        // same prompt (or its next chained step) can silently reappear the
        // next time the drawer opens, since checkCartForShieldUpsell()
        // re-derives its render from this same persisted data.
        cdStorageRemove('shield-upsell-data');
        cdStorageRemove('shield-upsell-product-id');
        cdStorageRemove('shield-upsell-consumable-data');
        cdStorageRemove('shield-upsell-consumable-heading');
        cdStorageRemove('shield-upsell-included-data');
        cdStorageRemove('shield-upsell-upgrades-data');
        cdStorageRemove('shield-upsell-accessories-data');
      }
      this.shieldSection.classList.remove('cart-drawer__shield-upsell--visible');
      if (this._shieldHideTimer) clearTimeout(this._shieldHideTimer);
      this._shieldHideTimer = setTimeout(() => {
        this.shieldSection.hidden = true;
        this._shieldHideTimer = null;
      }, 250);
    }

    async handleShieldAdd(variantId) {
      if (!variantId) return;
      var addBtn = this.querySelector('[data-shield-add="' + variantId + '"]');
      var addBtnOriginalText = addBtn ? addBtn.textContent : null;
      if (addBtn) addBtn.disabled = true;
      var bodyData = { id: parseInt(variantId, 10), quantity: 1 };
      var shieldItemsRaw = this.shieldSection?.dataset.shieldItems;
      if (shieldItemsRaw) {
        try {
          var allItems = JSON.parse(shieldItemsRaw);
          var found = Array.isArray(allItems) && allItems.find(function(s) {
            return String(s.variant_id) === variantId;
          });
          if (found && found.readiness) {
            bodyData.properties = { _readiness: found.readiness };
          }
        } catch (e) {}
      }
      try {
        var response = await fetch(cdCartUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(bodyData)
        });
        if (!response.ok) throw new Error();
        this.hideShieldUpsell();
        await this.fetchCart();

        if (this.shieldSection?.dataset?.includesMode === 'true') {
          var shieldItemsRaw = this.shieldSection.dataset.shieldItems;
          var addedItem = null;
          if (shieldItemsRaw) {
            try {
              var allItems = JSON.parse(shieldItemsRaw);
              addedItem = Array.isArray(allItems) && allItems.find(function(s) {
                return String(s.variant_id) === variantId;
              });
            } catch (e) {}
          }
          if (addedItem && addedItem.shield_series === 'DAF-1R') {
            var consumableRaw = cdStorageGet('shield-upsell-consumable-data');
            if (consumableRaw) {
              try {
                var consumables = JSON.parse(consumableRaw);
                var matchingConsumables = consumables;
                if (addedItem.consumable_types && Array.isArray(consumables)) {
                  matchingConsumables = cdFilterByConsumableTypes(addedItem, consumables) || consumables;
                }
                if (matchingConsumables && matchingConsumables.length) {
                  var heading = cdStorageGet('shield-upsell-consumable-heading') || this._defaultConsumableHeading();
                  document.dispatchEvent(new CustomEvent('cart-drawer:shield-upsell', {
                    detail: { shields: matchingConsumables, heading: heading }
                  }));
                }
              } catch (e) {}
            }
          }
          cdStorageRemove('shield-upsell-consumable-data');
          cdStorageRemove('shield-upsell-consumable-heading');
          cdStorageRemove('shield-upsell-included-data');
          cdStorageRemove('shield-upsell-upgrades-data');
          cdStorageRemove('shield-upsell-accessories-data');
          this.shieldSection.dataset.includesMode = 'false';
          return;
        }

        var consumableRaw = cdStorageGet('shield-upsell-consumable-data');
        if (consumableRaw) {
          cdStorageRemove('shield-upsell-dismissed');

          var shieldItemsRaw = this.shieldSection?.dataset.shieldItems;
          var matchingConsumables = null;
          if (shieldItemsRaw) {
            try {
              var shieldItems = JSON.parse(shieldItemsRaw);
              var shield = Array.isArray(shieldItems) && shieldItems.find(function (s) {
                return String(s.variant_id) === variantId;
              });
              if (shield && shield.consumable_types) {
                var consumables;
                try { consumables = JSON.parse(consumableRaw); } catch (e) { consumables = null; }
                if (consumables && consumables.length) {
                  matchingConsumables = cdFilterByConsumableTypes(shield, consumables);
                }
              }
            } catch (e) {}
          }

          if (matchingConsumables && matchingConsumables.length) {
            var heading = cdStorageGet('shield-upsell-consumable-heading') || this._defaultConsumableHeading();
            document.dispatchEvent(new CustomEvent('cart-drawer:shield-upsell', {
              detail: { shields: matchingConsumables, heading: heading }
            }));
          }

          var persistRaw = cdStorageGet('shield-upsell-consumable-data');
          if (persistRaw) {
            try {
              var persistItems = JSON.parse(persistRaw);
              if (persistItems && persistItems.length) {
                var addedItem = persistItems.find(function(c) { return String(c.variant_id) === variantId; });
                if (addedItem && addedItem.type) {
                  var remaining = persistItems.filter(function(c) { return c.type !== addedItem.type; });
                  if (remaining.length) {
                    var persistHeading = cdStorageGet('shield-upsell-consumable-heading') || this._defaultConsumableHeading();
                    cdStorageSet('shield-upsell-consumable-data', JSON.stringify(remaining));
                    document.dispatchEvent(new CustomEvent('cart-drawer:shield-upsell', {
                      detail: { shields: remaining, heading: persistHeading }
                    }));
                    return;
                  }
                }
              }
            } catch(e) {}
          }

          cdStorageRemove('shield-upsell-consumable-data');
          cdStorageRemove('shield-upsell-consumable-heading');
        }
      } catch (err) {
        console.error('CartDrawer shield add error:', err);
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = this.shieldAddErrorText;
          setTimeout(function() {
            addBtn.textContent = addBtnOriginalText || this.shieldAddText;
          }.bind(this), 2500);
        }
      }
    }

    updateHeaderCount(count) {
      const headerBadge = document.querySelector('.header__cart-count');
      if (headerBadge) {
        if (count > 0) {
          headerBadge.textContent = count;
          headerBadge.hidden = false;
        } else {
          headerBadge.hidden = true;
        }
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);
})();
